import { call, put, takeLatest } from 'redux-saga/effects';

import {
  setExamQuestions,
  setInitialTimePracticeExam,
  setPracticeExam,
  setResultsSummarized,
  setReviewMode,
} from '../actions/practiceExamActions';
import {
  setCantStudy,
  setLoading,
  setLoadingUpdateUserSettingQualForDailyQuiz,
  setMessage,
  setUser,
  setUserSettingQualForDailyQuiz,
  setUserSettingQualForDailyQuizMessage,
} from '../actions/userActions';
import { GET_LOGGED_STUDENT } from '../actions/userActionTypes';
import {
  getDoubleSubscription,
  getLoggedStudent as getLoggedStudentService,
  getUserProgressOnChapters,
  login as loginService,
  logout as logoutService,
  requestPassword as requestPasswordService,
  resetPasswordService,
  updateQualForDailyQuiz,
} from '../services/userService';
import { GENERIC_ERROR_MESSAGE } from '../utils/constants';
import history from '../utils/history';

/**
 * LoginSaga
 */
export function* loginSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(setExamQuestions([]));
    yield put(setPracticeExam({}));
    yield put(setResultsSummarized([]));
    yield put(setInitialTimePracticeExam(0));
    yield put(setReviewMode(false));
    yield put(setMessage(''));
    const response = yield call(
      loginService,
      action.email,
      action.password,
      action.rememberMe,
    );
    if (response.needsPasswordChange) {
      history.push(`/password-reset/${response.resetPasswordToken}`);
    } else {
      yield put(setUser(response.user));
      if (action.addUsername) {
        history.push('/app/account-settings');
      } else {
        history.push('/app/study');
      }
      yield call(getDoubleSubscription, response.user);
    }
  } catch (exception) {
    if (exception.response?.status !== 503) {
      yield put(
        setMessage(
          exception.response ? exception.response.data : GENERIC_ERROR_MESSAGE,
        ),
      );
    }
  } finally {
    yield put(setLoading(false));
  }
}

export function* logoutSaga() {
  try {
    const response = yield call(logoutService);
    if (!response) {
      throw Error('Logout Failure');
    }

    history.replace('/login');
  } catch (exception) {
    yield put(
      setMessage(
        exception.response ? exception.response.data : GENERIC_ERROR_MESSAGE,
      ),
    );
  }
}

export function* requestPassword(action) {
  try {
    yield put(setMessage(''));
    const response = yield call(requestPasswordService, action.email);
    if (response) {
      yield put(setMessage('true'));
    } else {
      yield put(
        setMessage('This email does not exist in database, please check it'),
      );
    }
  } catch (exception) {
    yield put(
      setMessage(
        exception.response ? exception.response.data : GENERIC_ERROR_MESSAGE,
      ),
    );
  }
}

export function* resetPasswordSagas(action) {
  try {
    yield put(setLoading(true));
    yield put(setMessage(''));
    yield call(
      resetPasswordService,
      action.password,
      action.confirmPassword,
      action.token,
    );
    history.push('/login');
  } catch (exception) {
    yield put(setLoading(false));
    yield put(
      setMessage(
        exception.response ? exception.response.data : GENERIC_ERROR_MESSAGE,
      ),
    );
  } finally {
    yield put(setLoading(false));
  }
}

/**
 * Get logged student
 */
export function* loggedStudentSaga() {
  yield takeLatest(GET_LOGGED_STUDENT, getLoggedStudent);
}

function* getLoggedStudent(action) {
  try {
    yield call(getLoggedStudentService);
  } catch (exception) {}
}

export function* getUserProgressOnChaptersSaga(action) {
  try {
    const response = yield call(
      getUserProgressOnChapters,
      action.studyId,
      action.studyMethod,
    );
    yield put(setCantStudy(response));
  } catch (err) {}
}

export function* updateUserSettingQualForDailyQuizSaga(action) {
  try {
    yield put(setLoadingUpdateUserSettingQualForDailyQuiz(true));
    const response = yield call(updateQualForDailyQuiz, action.qualId);

    const qualId = response.qualDailyQuiz;

    yield put(setUserSettingQualForDailyQuiz(qualId));

    const messageSuccess = {
      type: 'success',
      text: 'Qual updated successfully!',
    };

    yield put(setUserSettingQualForDailyQuizMessage(messageSuccess));
  } catch (error) {
    const messageError = {
      type: 'error',
      text: error.response.data,
    };
    yield put(setUserSettingQualForDailyQuizMessage(messageError));
  } finally {
    yield put(setLoadingUpdateUserSettingQualForDailyQuiz(false));
  }
}

export function* verifyIsMaintenanceSaga() {
  try {
    const response = yield call(getLoggedStudentService);
    if (!response.isMaintenance) {
      history.push('/dashboard');
    }
  } catch (error) {
    if (error.response.status !== 503) {
      history.push('/login');
    }
  }
}

export default function* sagas() {
  yield [loginSaga(), loggedStudentSaga()];
}
